import { z } from "zod";

import { language } from "@rootreeweb/ns-helper";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";

import type { FormDefinition } from "../types.js";

import DielineRequestEN from "./DielineRequestEN.js";
import { consentTextFR } from "./shared.js";

const dielineRequestFR: FormDefinition = {
	signature: "5c426096c5b10f39f9023362992bea4b58f5f6d13b091be180c6ee9d8cb14b57",
	formID: "dieline-request-fr",
	schema: z.object({
		Prenom: z.string(),
		"Nom de famille": z.string(),
		"E-mail": z.string().email(),
		Entreprise: z.string(),
		Language: language,
		"Numéro de téléphone": z.string(),
		"Type de produit": z.string().optional(),
		"Dimension du gabarit": z.string().optional(),
		"Y-a-t-il autre chose que devrions savoir ?": z
			.string()
			.optional()
			.describe(
				createCustomSettings({
					textArea: true,
				}),
			),
		consentTextFR,
	}),
	submissionOptions: {
		subject: (formState) =>
			`Customer Dieline Information Form (FR): ${formState["Prenom"]}`,
		preamble: "Submitted information",
		postamble:
			"Contact the Web Team if you have any issues with this the data in this email.",
		recipients: ["sales@rootree.ca", "web@rootree.ca"],
	},
	formOptions: {
		strings: {
			submitButton: "Envoyez-le dans!",
			success:
				"Envoi réussi ! Un membre de notre équipe vous contactera prochainement. Pour toute autre question, n'hésitez pas à nous contacter au 1-833-ROOTREE (766-8733).",
		},
		mapFieldsToForm: DielineRequestEN,
	},
};
export default dielineRequestFR;
